import { Directive, ElementRef, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SessionSetting } from '../../app.service';
import { Pslistener } from '../../pf.core/listener/Pslistener';

declare var $: any;

@Directive({
  selector: '[psDatepicker]'
})
export class PsDatepickerDirective implements OnInit {

  @Input() psDatepicker: any;
  private _element: any;
  @Output() ngModelChange = new EventEmitter();

  constructor(private el: ElementRef) {}

  ngOnInit() {
    // System.import('script-loader!jquery-ui-npm/jquery-ui.min.js').then(o => this.init());
    this.init();
  }

  private i18n(lanKey) {
    $.datepicker.setDefaults($.datepicker.regional[lanKey]);
  }

  private initI18n() {
    $.datepicker.regional['en-US'] = $.datepicker.regional['en'];
    $.datepicker.regional['zh-TW'] = {
      closeText: '關閉',
      prevText: '&#x3C;上個月',
      nextText: '下個月&#x3E;',
      currentText: '今天',
      monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月' ],
      monthNamesShort: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
      dayNames: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      dayNamesShort: ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
      dayNamesMin: ['日', '一', '二', '三', '四', '五', '六'],
      weekHeader: '週',
      dateFormat: 'yy/mm/dd',
      firstDay: 1,
      isRTL: false,
      showMonthAfterYear: true,
      yearSuffix: '年'
    };
    $.datepicker.regional['zh-CN'] = {
      closeText: '关闭',
      prevText: '&#x3C;上月',
      nextText: '下月&#x3E;',
      currentText: '今天',
      monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
      monthNamesShort: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
      dayNames: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      dayNamesShort: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      dayNamesMin: ['日', '一', '二', '三', '四', '五', '六'],
      weekHeader: '周',
      dateFormat: 'yy-mm-dd',
      firstDay: 1,
      isRTL: false,
      showMonthAfterYear: true,
      yearSuffix: '年'
    };
    $.datepicker.regional['ja-JP'] = {
      closeText: '閉じる',
      prevText: '&#x3C;前',
      nextText: '次&#x3E;',
      currentText: '今日',
      monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      monthNamesShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      dayNames: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
      dayNamesShort: ['日', '月', '火', '水', '木', '金', '土'],
      dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
      weekHeader: '週',
      dateFormat: 'yy/mm/dd',
      firstDay: 0,
      isRTL: false,
      showMonthAfterYear: true,
      yearSuffix: '年'
    };
    $.datepicker.regional['ko-KR'] = {
      closeText: '닫기',
      prevText: '이전달',
      nextText: '다음달',
      currentText: '오늘',
      monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
      monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
      dayNames: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
      dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
      dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
      weekHeader: '주',
      dateFormat: 'yy. m. d.',
      firstDay: 0,
      isRTL: false,
      showMonthAfterYear: true,
      yearSuffix: '년'
    };
  }

  private init() {
    let onSelectCallbacks = [];
    let saUiDatepicker = this.psDatepicker || {};

    this.initI18n();
    this._element = $(this.el.nativeElement);

    if (saUiDatepicker.minRestrict) {
      onSelectCallbacks.push((selectedDate) => {
        $(saUiDatepicker.minRestrict).datepicker('option', 'minDate', selectedDate);
      });
    }
    if (saUiDatepicker.maxRestrict) {
      onSelectCallbacks.push((selectedDate) => {
        $(saUiDatepicker.maxRestrict).datepicker('option', 'maxDate', selectedDate);
      });
    }

    // Let others know about changes to the data field
    onSelectCallbacks.push((selectedDate) => {
      this._element.triggerHandler('change');

      let form = this._element.closest('form');

      if (typeof form.bootstrapValidator === 'function') {
        try {
          form.bootstrapValidator('revalidateField', this._element);
        } catch (e) {
          console.log(e.message)
        }
      }
    });

    let options = $.extend(saUiDatepicker, {
      prevText: '<i class="fa fa-chevron-left"></i>',
      nextText: '<i class="fa fa-chevron-right"></i>',
      onSelect: (selectedDate) => {
        this.ngModelChange.emit(selectedDate);
        onSelectCallbacks.forEach((callback) => {
          callback.call(callback, selectedDate)
        })
      },
      dateFormat: 'yy/mm/dd',
      changeYear: true,
      // changeMonth: true
    });

    this._element.datepicker(options);

    Pslistener.i18n.subscribe(k => this.i18n(k));
    //www Pslistener.i18n.next(SessionSetting.getLanguage());
    this.i18n(SessionSetting.getLanguage());
  }
}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.core/datepicker/psdatepicker.directive.ts